// https://github.com/jquense/yup
// Dead simple Object schema validation

import * as yup from "yup";

const prProfileYupSchema = yup.object().shape({
  first_name: yup.string().required("First name is required."),
  last_name: yup.string().required("Last name is required."),
  // Trimmed before the length check because the value is trimmed before it is sent, and the server
  // strips it too — validating the untrimmed input would reject padding the user never submits.
  headline_custom: yup
    .string()
    .transform((value) => (typeof value === "string" ? value.trim() : value))
    .max(200, "Headline must be 200 characters or fewer."),
  location_string: yup.string().nullable().max(100, "Location must be 100 characters or fewer."),
  // description: yup.string().max(200, "Description must fewer than 200 characters."),
  // website_url: yup
  //   .string()
  //   .nullable()
  //   .test("valid-twitter-url", "Website must be a valid URL or blank.", (value) => {
  //     if (!value) return true; // Allow blank or null value
  //     if (!/^https:\/\//.test(value)) return false; // Must start with HTTPS
  //     return true; // Passes validation
  //   }),
  // twitter_url: yup
  //   .string()
  //   .nullable()
  //   .test("valid-twitter-url", "Twitter URL must be a valid URL or blank.", (value) => {
  //     if (!value) return true; // Allow blank or null value
  //     if (!/^https:\/\//.test(value)) return false; // Must start with HTTPS
  //     if (!/(www\.|)twitter.com\/.+/i.test(value)) return false; // Must be a valid Twitter profile URL
  //     return true; // Passes validation
  //   }),
  // linkedin_url: yup
  //   .string()
  //   .nullable()
  //   .test("valid-twitter-url", "LinkedIn URL must be a valid URL or blank.", (value) => {
  //     if (!value) return true; // Allow blank or null value
  //     if (!/^https:\/\//.test(value)) return false; // Must start with HTTPS
  //     if (!/(www\.|)linkedin.com\/.+/i.test(value)) return false; // Must be a valid Twitter profile URL
  //     return true; // Passes validation
  //   }),
  // facebook_url: yup
  //   .string()
  //   .nullable()
  //   .test("valid-twitter-url", "Facebook URL must be a valid URL or blank.", (value) => {
  //     if (!value) return true; // Allow blank or null value
  //     if (!/^https:\/\//.test(value)) return false; // Must start with HTTPS
  //     if (!/(www\.|)facebook.com\/.+/i.test(value)) return false; // Must be a valid Twitter profile URL
  //     return true; // Passes validation
  //   }),
  // show_twitter_feed: yup.boolean(),
});

export default prProfileYupSchema;
